import { getNumberOfUpgradeUnits } from 'src/utils/equipment-utils';

import { useProductsResponseQueryStateOrThrow } from './use-products-query';

export const useSelectMaximumStbPurchaseCount = () => {
  const { upgradeDecoder, numberOfOwnedUnits, maxNumberOfUnits } = useProductsResponseQueryStateOrThrow();
  const amountOfUpgradeUnits = getNumberOfUpgradeUnits(upgradeDecoder);

  return maxNumberOfUnits - Math.max(amountOfUpgradeUnits, numberOfOwnedUnits);
};
